import { render, staticRenderFns } from "./RecaptchaWidget.vue?vue&type=template&id=1b06a5c9&scoped=true&"
import script from "./RecaptchaWidget.vue?vue&type=script&lang=js&"
export * from "./RecaptchaWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06a5c9",
  null
  
)

export default component.exports